// extracted by mini-css-extract-plugin
export var addButton = "_p4-0";
export var border = "_p4-8";
export var check = "_p4-h";
export var danger = "_p4-6";
export var dropdownContainer = "_p4-1";
export var editModalBody = "_p4-j";
export var footerContainer = "_p4-i";
export var fullWidth = "_p4-a";
export var hide = "_p4-9";
export var icon = "_p4-3";
export var input = "_p4-7";
export var inputFlex = "_p4-b";
export var inputWrapper = "_p4-c";
export var manualFocus = "_p4-5";
export var optionButton = "_p4-4";
export var pillWrapper = "_p4-e";
export var pointer = "_p4-2";
export var showOverflow = "_p4-f";
export var tagsFlex = "_p4-d";
export var xButton = "_p4-g";